module.exports = __webpack_public_path__ + "img/9788974833862.868b3c58.jpg";